module.exports = __webpack_public_path__ + "static/img/14001016.cd5ee139.png";